import React, { useEffect, useState } from 'react';
import ElapsedTimer from './ElapsedTimer';

const WRAITH_LOGO = '/branding/wraith-logo.png';
const SPLASH_DURATION_MS = 5000;

export default function SplashScreen({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [startedAt] = useState(() => Date.now());

  useEffect(() => {
    const started = Date.now();
    const timer = window.setInterval(() => {
      const elapsed = Date.now() - started;
      const next = Math.min(100, Math.round((elapsed / SPLASH_DURATION_MS) * 100));
      setProgress(next);
      if (next >= 100) {
        window.clearInterval(timer);
        window.setTimeout(onComplete, 120);
      }
    }, 50);
    return () => window.clearInterval(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6">
      <img
        src={WRAITH_LOGO}
        alt="WRAITH"
        className="w-full max-w-2xl object-contain mb-10"
      />
      <p className="text-center text-base sm:text-lg text-gray-200 leading-relaxed max-w-2xl">
        Nation State Elicitation Modeling Tool
      </p>
      <div className="w-full max-w-xl mt-12">
        <div className="h-2 rounded-full bg-gray-900 border border-teal-500/30 overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-teal-600 to-teal-400 transition-[width] duration-100 ease-linear"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="mt-3 flex flex-col items-center gap-1">
          <p className="text-center text-sm text-teal-300 tracking-wide">
            Loading elicitation engine
          </p>
          <ElapsedTimer startedAt={startedAt} className="text-teal-400/80" />
        </div>
      </div>
    </div>
  );
}
